import Rate from './Rate';
import MultipleSelect from './MultipleSelect';
import Select from './Select';
import Description from './Description';

export const itemMap = {
    five_star_scoring: Rate,
    select: Select,
    multi_select: MultipleSelect,
    description: Description,
    questionnaire_description:null
};
